import ActionsForm from '@/shared/mixins/actionsForm'
import CommissionRepository from '@/shared/http/repositories/realestate/commission'
import { loading } from '@/shared/utils/UIHelper'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default{
  name: 'TableCommissions',
  mixins: [ActionsForm],
  data () {
    return {
      consultacomissao: [],
      selectedComissao: {},
      headTable: ['Corretor', 'Empreendimento', 'Valor Total', 'Comissão', 'Status', 'Nº de Parcelas', 'Parcelas Quitadas', 'Dt. da Venda', 'Cliente', 'Unidade', '']
    }
  },
  methods: {
    onLoad () {
      if (localStoreHelper.consulta.comissao() != null) {
        this.searchWithFilter(localStoreHelper.consulta.comissao(), true)
      } else {
        loading.push()
        CommissionRepository.GetAll(this.$refs.tableGridComission.pagingLimit, this.$refs.tableGridComission.pagingIndex)
          .then(Response => {
            loading.pop()
            this.consultacomissao = Response.data.data
            this.$refs.tableGridComission.LoadAllByData(Response)
          })
          .catch(Error => {
            loading.pop()
          })
      }
    },
    searchWithFilter (filter, isFilter) {
      loading.push()
      this.filter = filter
      this.isFilter = isFilter
      if (!this.isFilter) {
        this.$refs.tableGridComission.pagingIndex = 1
        this.$refs.tableGridComission.currentPage = 1
      }
      CommissionRepository.GetInfoTabelaPeloFiltroAdm(this.$refs.tableGridComission.pagingLimit, this.$refs.tableGridComission.pagingIndex, filter)
        .then(res => {
          if (res.status === 200) {
            loading.pop()
            let newRequestsArray = res.data.data
            let newResponse = res
            this.consultacomissao = newRequestsArray
            this.$refs.tableGridComission.LoadAllByData(newResponse)
          }
        })
        .catch(Error => {
          loading.pop()
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/commissions/components/TableCommissions/TableCommissions.js